import HuaweiDownloadExplanation from './huawei-download-explanation.vue';

export default HuaweiDownloadExplanation;
